/**
 * Phase ID — Legal page content (Terms, Privacy, Copyright, DMCA)
 */

export const LEGAL_PAGES = {
  terms: {
    title: "Terms of Use",
    updated: "2026-05-29",
    sections: [
      {
        heading: "Acceptance",
        body: "By using VedaPath you agree to these Terms. If you do not agree, please discontinue use of the platform.",
      },
      {
        heading: "Spiritual guidance",
        body: "Āchārya AI provides educational and devotional guidance. It is not a substitute for medical, legal, or mental-health care. Seek qualified professionals when needed.",
      },
      {
        heading: "Accounts",
        body: "You are responsible for safeguarding your credentials. Anonymous use of Āchārya AI is permitted; saved sādhana and chanting progress require a signed-in account.",
      },
      {
        heading: "Content",
        body: "Scriptural summaries and original commentary are provided for study. Do not reproduce large portions for commercial use without permission.",
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    updated: "2026-05-29",
    sections: [
      {
        heading: "Data we collect",
        body: "We store account email, optional profile and sādhana data, and usage needed to operate the service. Anonymous Acharya sessions use a generated session id without linking to your identity unless you sign in.",
      },
      {
        heading: "Email and messaging",
        body: "Transactional email (verification, password reset) is sent via our email provider. WhatsApp verification may be enabled in the future; you will be asked before any phone number is stored.",
      },
      {
        heading: "Contact",
        body: "Messages sent via Contact Acharya are delivered to contact@vedapath.in only. We do not publish personal contact details of teachers or staff.",
      },
      {
        heading: "Your choices",
        body: "You may request account deletion from Settings → Account. Cached audio and journey data are removed with your profile.",
      },
    ],
  },
  copyright: {
    title: "Copyright",
    updated: "2026-05-29",
    sections: [
      {
        heading: "VedaPath OS",
        body: "© 2026 VedaPath OS. All Rights Reserved. The VedaPath name, logo, UI, and original compilations are protected.",
      },
      {
        heading: "Scriptural material",
        body: "Traditional texts are in the public domain or used under fair-use principles for study. AI-generated summaries are original works of VedaPath.",
      },
      {
        heading: "User content",
        body: "You retain rights to journal and reflection text you submit. You grant VedaPath a license to store and display it only to you within your account.",
      },
    ],
  },
  dmca: {
    title: "DMCA Notice",
    updated: "2026-05-29",
    sections: [
      {
        heading: "Copyright complaints",
        body: "If you believe content on VedaPath infringes your copyright, send a notice to contact@vedapath.in with: identification of the work, the URL or description of the material, your contact information, and a statement of good faith.",
      },
      {
        heading: "Counter-notification",
        body: "If your content was removed in error, you may reply with a counter-notification including consent to jurisdiction and your signature.",
      },
    ],
  },
};
